var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 60,
    viewBox: "0 0 47 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0429 0.775146V8.15784H45.4256M38.0429 0.775146H8.11603V39.5575M38.0429 0.775146L45.4256 8.15784M45.4256 8.15784V51.7774H15.7407M15.1224 59.1492L15.1639 54.5096C15.2271 53.6275 15.3506 52.8511 15.5748 52.0885C16.2662 49.7455 17.1641 47.2988 17.9188 44.9479C18.3268 43.8919 18.3277 42.2571 18.4127 41.0145L18.6231 36.4134C18.7041 34.6591 19.2069 31.9862 16.77 31.8202C15.6913 31.7451 15.0355 32.2064 14.6295 32.8811C14.021 33.8985 13.4165 37.9385 12.8287 39.5763C12.646 40.085 12.5215 40.49 12.0326 40.5157C10.9302 40.57 8.6603 40.5127 8.01824 39.5239C7.17368 38.221 7.28036 36.7038 6.34197 35.1648C6.26789 34.991 6.26788 34.8952 6.43284 34.7934C6.83092 34.5524 7.67054 33.5765 8.12492 32.8238M8.11603 27.3406C6.67288 28.4331 5.05192 29.7439 3.60976 31.0043C2.74545 31.6483 2.56271 32.3022 2.31774 32.8337C1.79125 34.6966 1.53442 36.5724 1.00991 38.4176C0.761977 39.2918 0.647394 39.8242 0.873596 40.8466C1.33884 42.9456 3.02301 46.7555 3.81225 48.9553C4.62224 51.0494 5.01241 52.1597 4.99759 54.4671L4.94919 59.1374",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5841 14.6212L26.5781 11.6279",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6339 38.6395L26.6279 35.644",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9127 20.785L30.9044 16.8326C30.8795 15.5172 30.0726 14.6213 28.9088 14.6213H24.3015C22.4967 14.6213 21.8246 15.3591 21.8619 17.4017L21.8972 20.5869C21.9138 21.4258 22.2499 22.1172 22.8266 22.4925L29.9315 27.1258C30.5082 27.5031 30.8463 28.1924 30.8609 29.0314L30.9086 32.6297C30.948 34.6723 30.5808 35.6398 28.7761 35.6398H23.8679C22.7042 35.6398 21.8972 34.7461 21.8723 33.4286L21.8599 29.8198",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialIcon);
export default __webpack_public_path__ + "static/media/financial-icon.13aa5f3f.svg";
export { ForwardRef as ReactComponent };